import { CognitoUserPool } from "amazon-cognito-identity-js";
import { getEnv } from "@/config/env";

const poolData = {
  UserPoolId: getEnv("VITE_COGNITO_USER_POOL_ID"),
  ClientId: getEnv("VITE_COGNITO_CLIENT_ID"),
};

export const userPool = new CognitoUserPool(poolData);
